export default "__VITE_ASSET__BMdOu8Xb__"